import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL || "";

/** Interfaz TenantType */
export interface TenantType {
	id: number;
	name: string;
}

/** Interfaz Tenant desde la API */
export interface Tenant {
	id: number;
	Name: string;
	nameDisplay: string | null;
	chargebeeCustomerId: string | null;
	tenantTypeId: number | null;
	TenantType: TenantType | null;
}

/** Interfaz principal Partner */
export interface Partner {
	id: number;
	displayName: string;
	name: string;
	domain: string | { name: string } | null;
	subtypeHardware: string | { name: string } | null;
	productList: string;
}

/** Interfaz principal Customer */
export interface Customer {
	id: number;
	displayName: string;
	name: string;
	domain: string | { name: string } | null;
	subtypeHardware: string | { name: string } | null;
	productList: string;
}

/** Interfaz TenantDetail desde la API */
export interface TenantDetail {
	id: number;
	Name: string;
	Domain: string | null;
	OrgID: string | null;
	chargebeeCustomerId: string | null;
	jiraOrganizationId: string | null;
	nameDisplay: string | null;
	hasMFA: boolean;
	tenantTypeId: number | null;
	canAccessAlerts: boolean;
	createdAt: string;
	updatedAt: string;
	TenantType: TenantType | null;
}

/** GET /v1/resource-manager/tenants */
export function getTenants(token: string) {
	return axios.get(`${API_URL}/v1/resource-manager/tenants`, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}

/** GET /v1/resource-manager/tenants/:id */
export function getTenantById(token: string, id: string | number) {
	return axios.get(`${API_URL}/v1/resource-manager/tenants/${id}`, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}